import getInstanceAxios from './RequestGlobalConfig';

export default getInstanceAxios(process.env.REACT_APP_PRODUCTCATALOG_VIEW_SERVICE_MSA);
